import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as myGlobal from 'global';

@Injectable( {
    providedIn: 'root'
} )
export class ForgotPasswordService {
    constructor( private http: HttpClient ) {
    }

    forgotPassword( model: any ) {
        const postJSON = {
            'email_id': model.email_id,
        };
        const httpHdr = new HttpHeaders( {
            [ myGlobal.CONTENT_TYPE ]: 'application/json'
        } );
        return this.http.post( myGlobal.AUTHENTICATION + '/' + 'send_verification_code', postJSON, {observe: 'response'} );
    }
}
